

import "./../scss/main.scss";

import lazySizes from "lazysizes";
//lazySizes.cfg.loadMode = 3;
lazySizes.cfg.preloadAfterLoad = true;

import "./navigation";
import "./swiper";
import "./scrollnav";
//import "./price";
import "./lottie";
import "./accordion";
import "./select";
import "./cta";
import "./alert";
import "./lightbox";
import "./video";
import "./scrollprogress";
import "./manualnav";
import "./blog";
import "./expand";